import { UserOnboardingContainer } from 'components/shared/onboarding/UserOnbaording/UserOnboardingContainer';

export const UserOnboarding = (): JSX.Element => {
  return <UserOnboardingContainer />;
};
